/* eslint-disable prefer-destructuring */
// if string contains only numbers
const regex = /^[\d\s]*$/;
export const handleNumericChange = (setter, actionType, dispatch) => event => {
  const value = event.target.value;

  if (regex.test(value)) {
    const numericValue = Number(value);
    setter(numericValue);
    dispatch({
      type: actionType,
      payload: numericValue
    });
  }
};
export const handleTimeChange = setter => event => {
  const value = event.target.value;

  if (regex.test(value)) {
    setter(event);
  }
};
export const isTimerEmpty = (hour, minute) => (hour === '00' || hour === '0' || hour === 0) && (minute === '00' || minute === '0' || minute === 0);
/** Minutes from PIM `PatientVisit.duration` and/or app visit `durationmins` (e.g. pimreader row). */

export const getDurationMinutesFromVisitSources = (savedVisit, appVisit) => {
  if ((savedVisit === null || savedVisit === void 0 ? void 0 : savedVisit.duration) != null && `${savedVisit.duration}` !== '') {
    const n = Number(savedVisit.duration);
    if (!Number.isNaN(n) && n > 0) return n;
  }

  const dm = appVisit === null || appVisit === void 0 ? void 0 : appVisit.durationmins;

  if (dm != null && dm !== undefined) {
    const n = Number(dm);
    if (!Number.isNaN(n) && n > 0) return n;
  }

  return null;
};
/** Two-digit HH and MM strings for visit timer inputs. */

export const minutesToTimerHhMmParts = totalMinutes => {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;

  const pad = n => Math.max(0, n).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });

  return [pad(h), pad(m)];
};